import React from 'react';
import PropTypes from 'prop-types';

const HelpText = ({ children, ...rest }) => <small className="c-form__help" {...rest}>
    {children}
  </small>

export default HelpText;

HelpText.propTypes = {
  children: PropTypes.node,
};
HelpText.defaultProps = {
  children: null,
};
